<template>
  <Dialog
    v-model:visible="visible"
    :modal="modal"
    :closable="closable"
    :closeOnEscape="closeOnEscape"
    :dismissableMask="dismissableMask"
    :draggable="false"
    :position="position"
    :maximizable="maximizable"
    :style="{ width: dialogSize }"
    :breakpoints="{ '640px': '90vw' }"
    @after-hide="emit('close')"
    :pt="{
      root: {
        class: 'border-charcoal-200 dark:border-charcoal-800 flex flex-col'
      },
      content: {
        class: 'flex flex-col flex-1 overflow-auto'
      },
      headerActions: {
        class: [
          'ml-3'
        ]
      },
      pcCloseButton: {
        root: {
          class: [
            'hover:bg-iris-600 hover:text-white'
          ]
        }
      },
      pcMaximizeButton: {
        root: {
          class: [
            'hover:bg-iris-600 hover:text-white'
          ]
        }
      }
    }"
  >
    <!-- Header Slot -->
    <template #header>
      <div v-if="header" class="font-semibold text-xl">
        {{ header }}
      </div>
      <slot v-else name="header" />
    </template>

    <!-- Default Slot -->
    <slot/>

    <!-- Footer Slot -->
     <template #footer v-if="$slots.footer">
       <slot name="footer"/>
     </template>
  </Dialog>
</template>

<script setup>
import { computed } from 'vue'
import Dialog from 'primevue/dialog'

const props = defineProps({
  // To show or not show the 'X' icon in the header
  closable: {
    type: Boolean
  },
  // Whether the Dialog should close on Escape key press or not
  closeOnEscape: {
    type: Boolean,
    default: true
  },
  // Whether to close Modal when clicking on overaly
  dismissableMask: {
    type: Boolean
  },
  // If using the Header Prop otherwise has a slot to allow own styled Header
  header: {
    type: String
  },
  // Add icon to make Dialog full screen or back to original size.
  maximizable: {
    type: Boolean,
    default: false
  },
  // Used to determine if modal (show background overlay) or not.
  modal: {
    type: Boolean,
    default: true
  },
  // Position of the Dialog
  position: {
    type: String,
    validator: (val) => ['left', 'right', 'top', 'bottom', 'center', 'topleft', 'topright', 'bottomleft', 'bottomright'].includes(val),
    default: 'center'
  },
  // Position of the Dialog
  size: {
    type: String,
    validator: (val) => ['xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge', 'xxxlarge'].includes(val),
    default: 'small'
  }
})

const emit = defineEmits(['close'])

const visible = defineModel()

// This mimics Tailwind w-xs, w-sm, w-md, w-lg, w-xl, w-2xl and w-3xl
const dialogSize = computed(() => {
  return {
    'xsmall': '20rem',
    'small': '24rem',
    'medium': '28rem',
    'large': '32rem',
    'xlarge': '36rem',
    'xxlarge': '42rem',
    'xxxlarge': '48rem',
  }[props.size]
})
</script>
